
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { cn } from '@/lib/utils';

interface MessageTextareaProps {
  value: string;
  onChange: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  minRows?: number;
  maxRows?: number;
}

const MessageTextarea: React.FC<MessageTextareaProps> = ({
  value,
  onChange,
  onKeyDown,
  placeholder = "Type your message...",
  disabled = false,
  className,
  minRows = 1,
  maxRows = 9
}) => {
  return (
    <TextareaAutosize
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      disabled={disabled}
      data-copilot-input="true"
      className={cn(
        "w-full resize-none border-0 bg-transparent text-sm placeholder:text-muted-foreground focus:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        "min-h-[20px] max-h-[180px] leading-relaxed scrollbar-none",
        className
      )}
      minRows={minRows}
      maxRows={maxRows}
      cacheMeasurements={true}
    />
  );
};

export default MessageTextarea;
